import { render } from "./AuctionArchive.vue?vue&type=template&id=6f1c0a2e&scoped=true&ts=true"
import script from "./AuctionArchive.vue?vue&type=script&lang=ts"
export * from "./AuctionArchive.vue?vue&type=script&lang=ts"

import "./AuctionArchive.vue?vue&type=style&index=0&id=6f1c0a2e&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1c0a2e"]])

export default __exports__